import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUsers, faCrown, faStore, faDollarSign } from '@fortawesome/free-solid-svg-icons';

export default function TemplateCard({ template, onClick }) {
  const rating = template.rating || 0;
  const usageCount = template.usageCount || 0;
  const price = template.price;

  const getSourceIcon = () => {
    if (template.vendorId) return faStore;
    if (template.createdBy === 'platform') return faCrown;
    return faUsers;
  };

  const getSourceLabel = () => {
    if (template.vendorId) return 'Vendor';
    if (template.createdBy === 'platform') return 'Platform';
    return 'Community';
  };

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl border-2 border-border p-6 cursor-pointer hover:border-primary hover:shadow-lg transition-all"
    >
      {/* Template Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-bold text-text-primary mb-2">{template.name}</h3>
          <div className="flex items-center gap-2 mb-2">
            <FontAwesomeIcon 
              icon={getSourceIcon()} 
              className={`text-sm ${
                template.createdBy === 'platform' ? 'text-accent' : 
                template.vendorId ? 'text-primary' : 'text-text-secondary'
              }`}
            />
            <span className="text-xs text-text-secondary">{getSourceLabel()}</span>
          </div>
        </div>
        {price && price > 0 && (
          <div className="flex items-center gap-1 px-3 py-1 bg-primary/10 rounded-full">
            <FontAwesomeIcon icon={faDollarSign} className="text-primary text-sm" />
            <span className="text-sm font-semibold text-primary">{price}</span>
          </div>
        )}
      </div>

      {/* Description */}
      {template.description && (
        <p className="text-sm text-text-secondary mb-4 line-clamp-2">
          {template.description}
        </p>
      )}

      {/* Stats */}
      <div className="flex items-center gap-4">
        {/* Rating */}
        <div className="flex items-center gap-1">
          <FontAwesomeIcon icon={faStar} className="text-yellow-400 text-sm" />
          <span className="text-sm font-semibold text-text-primary">{rating.toFixed(1)}</span>
        </div>

        {/* Usage */}
        <div className="flex items-center gap-1">
          <FontAwesomeIcon icon={faUsers} className="text-text-secondary text-sm" />
          <span className="text-xs text-text-secondary">{usageCount} uses</span>
        </div>
      </div>

      {/* Experience Type Badge */}
      {template.typeId && (
        <div className="mt-4">
          <span className="text-xs px-2 py-1 bg-primary/10 text-primary rounded-full font-semibold">
            {template.typeId}
          </span>
        </div>
      )}
    </div>
  );
}
